import { social } from '../links'

export const buildOrganizationJsonLd = (siteUrl: string, siteName: string) => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteName,
  url: siteUrl,
  sameAs: [social.facebook, social.instagram, social.linkedin],
})

export const buildWebSiteJsonLd = (siteUrl: string, siteName: string) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteName,
  url: siteUrl,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/d/initiatieven?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
})
